var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"message"}},[_c('div',{staticClass:"title"},[_vm._v("总表实时信息")]),_c('div',{staticClass:"num_1"},[_c('p',[_vm._v(_vm._s(_vm.allpress))])]),_c('div',{staticClass:"num_2"},[_c('p',[_vm._v(_vm._s(_vm.flowrate))])])])}
var staticRenderFns = []

export { render, staticRenderFns }